
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"en":{"<SINGLE_COLOR>":"Single-color","<CLASSIFICATION>":"Multi-color","<HIGHLIGHTING>":"Rule-based"},"de":{"<SINGLE_COLOR>":"Einfarbig","<CLASSIFICATION>":"Mehrfarbig","<HIGHLIGHTING>":"Regelbasiert"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();